import { render, staticRenderFns } from "./GroupServiceSetting.vue?vue&type=template&id=c6a3d846"
import script from "./GroupServiceSetting.js?vue&type=script&lang=js&external"
export * from "./GroupServiceSetting.js?vue&type=script&lang=js&external"
import style0 from "./GroupServiceSetting.vue?vue&type=style&index=0&id=c6a3d846&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports